/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Total_Characters_LabelInputs */

const en_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Characters`)
};

const fr_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des caracteres`)
};

const de_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtanzahl Zeichen`)
};

const it_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero totale di personaggi`)
};

const ru_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общее количество символов`)
};

const es_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres totales`)
};

const zh_cn2_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总字符数`)
};

const ja_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計文字数`)
};

const hi_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल अक्षर`)
};

const pt_pt2_style_guide_manager_total_characters_label = /** @type {(inputs: Style_Guide_Manager_Total_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de caracteres`)
};

/**
* | output |
* | --- |
* | "Total Characters" |
*
* @param {Style_Guide_Manager_Total_Characters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_total_characters_label = /** @type {((inputs?: Style_Guide_Manager_Total_Characters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Total_Characters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_total_characters_label(inputs)
	if (locale === "de") return de_style_guide_manager_total_characters_label(inputs)
	if (locale === "it") return it_style_guide_manager_total_characters_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_total_characters_label(inputs)
	if (locale === "es") return es_style_guide_manager_total_characters_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_total_characters_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_total_characters_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_total_characters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_total_characters_label(inputs)
	return en_style_guide_manager_total_characters_label(inputs)
});